import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["dataSource", "dataTree", "value", "codeFields", "checkedCode", "display"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useMemo, useEffect } from 'react'; // import { getValuePath } from '@U/tool';

import _ from 'lodash';
import { useEnum } from '@/hooks'; // import { getPropPath, getFormValue } from '@/store';

import RowSelect from '../RowSelect';
const DefaultCodeFields = ['provinceCode', 'cityCode', 'countyCode']; // const DefaultCodeFields = ['insureProvinceCode', 'insureCityCode', 'insureCountyCode'];

export const filterInitTreeNodes = item => {
  item = _.cloneDeep(item);

  if ('children' in item) {
    switch (item._checked) {
      case 0:
        item.children = [];
        break;

      case 1:
        item.children = item.children ? item.children.filter(c => c._checked) : null;
        break;

      case 2:
        item.children = item.children.filter(c => c._checked).map(child => filterInitTreeNodes(child));
        break;
    }

    delete item._checked;
  }

  return item;
}; // 获取带_checked数据

export const useGetCheckedTreeNodes = (treeData, checkedCodes, AreaItemKeys) => {
  var _treeData, _treeData$children;

  const {
    codeKey = 'code',
    childrenKey = 'children',
    labelKey = 'name'
  } = AreaItemKeys || {}; // 添加全国

  treeData = {
    [childrenKey]: (_treeData = treeData) !== null && _treeData !== void 0 && _treeData.length ? _.cloneDeep(treeData) : [],
    [labelKey]: '全国',
    [codeKey]: 'all',
    _checked: 0
  };

  const checkedChildItem = (item, _checkedCodes, parentChecked) => {
    var _item$childrenKey;

    item._checked = parentChecked || (_checkedCodes !== null && _checkedCodes !== void 0 && _checkedCodes.includes(item[codeKey]) ? 1 : 0);
    const hasChild = ((_item$childrenKey = item[childrenKey]) === null || _item$childrenKey === void 0 ? void 0 : _item$childrenKey.length) > 0;

    if (hasChild) {
      var _item$childrenKey2;

      item[childrenKey] = (_item$childrenKey2 = item[childrenKey]) === null || _item$childrenKey2 === void 0 ? void 0 : _item$childrenKey2.map(child => {
        return checkedChildItem(child, _checkedCodes, item._checked);
      });
    }

    return item;
  };

  const checkedParentItem = item => {
    var _item$childrenKey3;

    const hasChild = ((_item$childrenKey3 = item[childrenKey]) === null || _item$childrenKey3 === void 0 ? void 0 : _item$childrenKey3.length) > 0;

    if (hasChild) {
      const next = item[childrenKey].map(child => checkedParentItem(child));
      const hasCheckedChild = next.filter(c => c._checked === 1);
      const hasIndeterminate = next.filter(c => c._checked === 2);
      let checked = 2;

      if (!hasCheckedChild.length && !hasIndeterminate.length) {
        checked = 0;
      } else if (hasCheckedChild.length === next.length) {
        checked = 1;
      }

      item._checked = checked;
      return _objectSpread(_objectSpread({}, item), {}, {
        [childrenKey]: next
      });
    }

    return item;
  };

  const getCheckedNodes = (node, _checkedCodes) => {
    const next = checkedChildItem(node, _checkedCodes, 0);
    const next2 = checkedParentItem(next);
    return next2;
  };

  const [checkedTreeNodes, setCheckedTreeNodes] = useState(treeData);
  useEffect(() => {
    if (Array.isArray(checkedCodes)) {
      const initialState = getCheckedNodes(treeData, checkedCodes);
      setCheckedTreeNodes(initialState);
    }
  }, [(_treeData$children = treeData.children) === null || _treeData$children === void 0 ? void 0 : _treeData$children.length, checkedCodes === null || checkedCodes === void 0 ? void 0 : checkedCodes.length]);
  return [checkedTreeNodes];
}; // 获取投保流程过滤数据

export const useGetFilterTreeNodes = (treeData, checkedCodes, AreaItemKeys) => {
  var _checkedTreeNodes$chi;

  const {
    codeKey = 'code',
    childrenKey = 'children',
    labelKey = 'name'
  } = AreaItemKeys || {};
  const [checkedTreeNodes] = useGetCheckedTreeNodes(treeData, checkedCodes, AreaItemKeys);
  const [treeNodes, setTreeNodes] = useState([]);
  useEffect(() => {
    if (checkedTreeNodes !== null && checkedTreeNodes !== void 0 && checkedTreeNodes.children) {
      const filterTreeNodes = filterInitTreeNodes(checkedTreeNodes);
      setTreeNodes(filterTreeNodes === null || filterTreeNodes === void 0 ? void 0 : filterTreeNodes[childrenKey]);
    }
  }, [checkedTreeNodes === null || checkedTreeNodes === void 0 ? void 0 : (_checkedTreeNodes$chi = checkedTreeNodes.children) === null || _checkedTreeNodes$chi === void 0 ? void 0 : _checkedTreeNodes$chi.length]);
  return [treeNodes];
};

function removeDuplicate(selected) {
  if ((selected[0] && selected[0].name) === (selected[1] && selected[1].name)) {
    selected = selected.slice(1);
  }

  return selected;
}

function displayRender(selected) {
  selected = removeDuplicate(selected);
  selected = removeDuplicate(selected);
  return selected.map(item => item.name).join('/');
}

function ensure3Cols(list) {
  list.forEach(item => {
    if (!item.children) {
      item.children = [_objectSpread({}, item)];
    }

    item.children.forEach(item2 => {
      if (!item2.children) {
        item2.children = [_objectSpread({}, item2)];
      }
    });
  });
  return list;
}

export default function RowArea(props) {
  const {
    label,
    formKey,
    attrs = {},
    component
  } = props;

  const {
    dataSource,
    dataTree,
    value,
    codeFields = DefaultCodeFields,
    checkedCode,
    display = {}
  } = attrs,
        rest = _objectWithoutProperties(attrs, _excluded);

  let defaultValue;

  if (display !== null && display !== void 0 && display.defaultValue && Array.isArray(JSON.parse(display === null || display === void 0 ? void 0 : display.defaultValue))) {
    defaultValue = JSON.parse(display === null || display === void 0 ? void 0 : display.defaultValue).join(',');
  } // let localCodeFields = codeFields;


  const cols = 3; // if (component === 'insureRegion') {
  //   cols = 2;
  //   // localCodeFields = ['insureProvinceCode', 'insureCityCode'];
  // }
  // const [areaList, setArea] = useState([]);

  const [areaList] = useEnum('district');
  const [treeNodes] = useGetFilterTreeNodes(areaList, checkedCode, {
    codeKey: 'code',
    labelKey: 'name',
    childrenKey: 'children'
  });
  const list = useMemo(() => {
    if (treeNodes) {
      return ensure3Cols(treeNodes);
    }

    return treeNodes;
  }, [treeNodes]); // let arrValue = useMemo(() => {
  //   return getValuePath(value, treeNodes, 'code').map((item) => item.code);
  // }, [value, treeNodes]);
  // const storeValue = getFormValue(formKey);
  // if (storeValue) {
  //   arrValue = _.isString(storeValue) ? storeValue.split(',') : [];
  // }
  // const nodes = useMemo(() => {
  //   return localCodeFields.map((key) => getPropPath(formKey, key));
  // }, [formKey]);
  // const [finalValue, setFinalValue] = useState(arrValue);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RowSelect, _extends({}, props, {
    formKey: formKey,
    displayRender: displayRender,
    dataSource: list,
    textMember: "name",
    valueMember: "code",
    cols: cols,
    defaultValue: defaultValue
  })));
}